import i18n from "@verbleif/lib/src/translations/i18n";
import { isScreenshotMode } from "@web/core/runtimeFlags";
import Gleap from "gleap";

if (!isScreenshotMode) {
  Gleap.setUseCookies(true);
  Gleap.initialize("2eTQhFITCETzRhSy7qpFzzkWH6vRPd0h");
  Gleap.setLanguage(i18n.global.locale.value ?? "nl");
  const mode = import.meta.env.MODE;
  const gleapEnv = mode === "production" ? "prod" : mode === "test" ? "staging" : "dev";
  Gleap.setEnvironment(gleapEnv);
  Gleap.showFeedbackButton(false);
}
